import GRIGORA_APP from "../../../package.json";
import React, { createContext, useContext, useEffect } from "react";
import { WhiteLabelContext } from "../whitelabel";
import { WEBCLIP_URL } from "../app";
import WebFont from "webfontloader";

const GrigoraVersioningContext = createContext();

const GrigoraVersioning = (props) => {
  const { __whitelabel__ } = useContext(WhiteLabelContext) ?? {};

  // Update favicon of whitelabel
  useEffect(() => {
    const favicon = __whitelabel__("favicon", WEBCLIP_URL);

    if (favicon) {
      if (document.querySelector("link[rel='icon']")) {
        document.querySelector("link[rel='icon']").href = favicon;
      } else {
        const faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        faviconLink.href = favicon;
        document.head.appendChild(faviconLink);
      }
    }
  }, []);

  // Update tailwind colors of whitelabel and font family
  useEffect(() => {
    const primaryColor = __whitelabel__("primaryColor");
    const primaryButtonColor = __whitelabel__("primaryButtonColor");
    const secondaryButtonColor = __whitelabel__("secondaryButtonColor");
    const lightBlueBackgroundColor = __whitelabel__("lightBlueBackgroundColor");
    const redColor = __whitelabel__("redColor");
    const fontFamily = __whitelabel__("fontFamily");

    if (primaryColor) {
      document.documentElement.style.setProperty(
        "--color-ui-blue",
        primaryColor,
      );
    }
    if (primaryButtonColor) {
      document.documentElement.style.setProperty(
        "--color-ui-green",
        primaryButtonColor,
      );
    }
    if (secondaryButtonColor) {
      document.documentElement.style.setProperty(
        "--color-ui-og-blue",
        secondaryButtonColor,
      );
    }
    if (redColor) {
      document.documentElement.style.setProperty("--color-ui-red", redColor);
    }
    if (lightBlueBackgroundColor) {
      document.documentElement.style.setProperty(
        "--color-ui-light-blue-background",
        lightBlueBackgroundColor,
      );
    }

    if (fontFamily) {
      WebFont.load({
        google: {
          families: [fontFamily],
        },
      });
      document.documentElement.style.setProperty("--font-family", fontFamily);
    }
  }, []);

  return (
    <GrigoraVersioningContext.Provider
      value={{
        version: GRIGORA_APP.version,
        versionName: GRIGORA_APP.versionName,
      }}
    >
      {props.children}
    </GrigoraVersioningContext.Provider>
  );
};
export { GrigoraVersioning, GrigoraVersioningContext };
